const $giftModal = $('.js-gift-modal');
const $giftModalContinue = $('.js-gift-modal-continue');
const $giftModalStart = $('.js-gift-modal-start');
const $giftModalAnimation = $('.js-gift-modal-animation');
const $giftModalForm = $('.js-gift-modal-form');
const $giftModalEnd = $('.js-gift-modal-end');
const $giftModalError = $('.js-gift-modal-error');

const giftModal = {
  initialize() {
    if ($giftModal.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $giftModalContinue.on('click', (e) => {
      e.preventDefault();
      const $target = $(e.currentTarget);
      const API = $target.data('api');
      const giftId = $target.data('gift-id');

      let formData = new FormData();

      if ($giftModalForm.length) {
        formData = new FormData($giftModalForm.get(0));
      }

      formData.append('gift_id', giftId);

      $target.attr('disabled', true);

      $.ajax({
        method: 'POST',
        url: API,
        data: formData,
        processData: false,
        contentType: false,
      })
        .done(() => {
          this.startAnimation();
        })
        .fail((response) => {
          $target.attr('disabled', false);
          this.error(response);
        });
    });
  },

  startAnimation() {
    $giftModalStart.fadeOut(() => {
      $giftModalAnimation.fadeIn();

      setTimeout(() => {
        $giftModalAnimation.fadeOut(() => {
          $giftModalEnd.fadeIn();
        });
      }, 2000);
    });
  },

  error(response) {
    $giftModalError
      .show()
      .text(response.responseText);
  },
};

export default giftModal;
